import { FC } from 'react';

type Props = {
  value: string;
};

/**
 * Номер обращения HelpDeskEddy в ячейке таблицы. Номер длиннее колонки переносится по символам:
 * перенос по словам оставил бы префикс номера отдельной строкой, а остаток — третьей.
 */
export const C2EddyTicketNumber: FC<Props> = ({ value }) => <span className="break-all">{value}</span>;
